<mat-card>
  <mat-card-content>
    <ui-form-textarea [formControl]="referenceTextResponseControl" [data]="dataAlias"></ui-form-textarea>
  </mat-card-content>
</mat-card>
